<div class="card-container">
  <div class="title-wrapper">
    <h3>Room Name</h3>
  </div>
  <div class="input-div">
    <mat-form-field appearance="outline">
      <mat-label>Name your room</mat-label>
      <input matInput placeholder="Name your room" [formControl]="nameInput" required />
    </mat-form-field>
  </div>
  <div class="footer-wrapper">
    <button data-testid="primaryButton" [disabled]="disableApplyButton()" class="primary-button" (click)="nextStep()">
      {{ isCreateFlow ? 'Next' : 'Apply' }}
    </button>
  </div>
</div>
